<template>
  <div>
    <b-card class="wrapper" v-if="!hideDispositions">
      <div>
        <b-button variant="info" @click="openChangeStatus">
          <font-awesome-icon icon="repeat" /> Change Status
        </b-button>
        <!-- <b-button variant="info" @click="showTransfer">
          <font-awesome-icon icon="exchange"/> Transfer
        </b-button> -->
        <b-button variant="warning" @click="showCallback">
          <font-awesome-icon icon="calendar-alt" /> Callback
        </b-button>
        <b-button variant="primary" @click="openReleaseCallback">
          <font-awesome-icon icon="calendar" /> Release Callback
        </b-button>
        <b-button variant="danger" @click="showUnavailable">
          <font-awesome-icon icon="ban" /> Unavailable
        </b-button>
        <b-button variant="danger" @click="showNotInterested">
          <font-awesome-icon icon="times" /> Not Interested
        </b-button>
        <b-button variant="danger" @click="showInvalid">
          <font-awesome-icon icon="times-circle" /> Invalid Details
        </b-button>
        <b-button v-if="hasAppointment" variant="primary" @click="openBookingsModal">
          <font-awesome-icon icon="calendar" /> Reschedule Appointment
        </b-button>
        <b-button v-if="!hasAppointment" variant="primary" @click="openBookingsModal">
          <font-awesome-icon icon="calendar" /> Set Appointment
        </b-button>
        <ChangeStatusModal ref="changeStatusModal" :companyId="companyId" :lookups="lookups" />
        <ReleaseCallbackModal ref="releaseCallbackModal" :companyId="parseInt(companyId)" :onRelease="reloadData" />
        <SetAppointment ref="setAppointmentModal" :companyId="companyId" :vendors="vendors" :reschedule="hasAppointment"/>
      </div>
    </b-card>

    <CompanyTransferCreate :companyId="companyId" v-if="!hideTransfer" />
    <CompanyCallback :companyId="companyId" v-if="!hideCallback" />
    <UnavailableReason :companyId="companyId" :lookups="lookups" v-if="!hideUnavailable" />
    <NotInterestedReason :companyId="companyId" :lookups="lookups" v-if="!hideNotInterested" />
    <InvalidReason :companyId="companyId" :lookups="lookups" v-if="!hideInvalid" />


  </div>
</template>

<script>
import ChangeStatusModal from "@/components/company/dispositions/ChangeStatusModal.vue";
import CompanyTransferCreate from "@/components/company/dispositions/CompanyTransferCreate.vue";
import CompanyCallback from "@/components/company/dispositions/CompanyCallback.vue";
import ReleaseCallbackModal from "@/components/company/dispositions/ReleaseCallbackModal.vue";
import NotInterestedReason from "@/components/company/dispositions/NotInterestedReason.vue";
import InvalidReason from "@/components/company/dispositions/InvalidReason.vue";
import UnavailableReason from "@/components/company/dispositions/UnavailableReason.vue";
import SetAppointment from "@/components/company/shared/SetAppointment.vue"

export default {
  name: "Dispositions",
  props: {
    companyId: String,
    lookups: Object,
    vendors: Array,
    appointments: null,
  },
  data() {
    return {
      hideDispositions: false,
      hideTransfer: true,
      hideCallback: true,
      hideUnavailable: true,
      hideNotInterested: true,
      hideInvalid: true,
      hideSetAppointment: true,
      hasAppointment: false,
    };
  },
  components: { ChangeStatusModal, CompanyTransferCreate, CompanyCallback, ReleaseCallbackModal, NotInterestedReason, InvalidReason, UnavailableReason, SetAppointment },
  watch: {
    appointments: function () {
      this.hasAppointment = this.appointments.filter(x => x.isCurrent == true).length > 0;
    },
  },
  methods: {
    openChangeStatus() {
      this.$refs.changeStatusModal.showModal();
    },

    showDispositions() {
      this.hideDispositions = false;
      this.hideTransfer = true;
      this.hideCallback = true;
      this.hideInvalid = true;
      this.hideUnavailable = true;
      this.hideNotInterested = true;
    },
    showTransfer() {
      this.hideTransfer = false;
      this.hideDispositions = true;

      this.$http.post("/company/createtransfer/" + this.companyId).then(() => { });
    },
    showInvalid() {
      this.hideInvalid = false;
      this.hideDispositions = true;
    },
    showUnavailable() {
      this.hideUnavailable = false;
      this.hideDispositions = true;
    },
    showNotInterested() {
      this.hideNotInterested = false;
      this.hideDispositions = true;
    },
    showCallback() {
      this.hideCallback = false;
      this.hideDispositions = true;
    },
    openReleaseCallback() {
      this.$refs.releaseCallbackModal.showModal();
    },
    reloadData() {
      this.$parent.loadData()
    },
    openBookingsModal() {
      this.$refs.setAppointmentModal.showModal();
    }
  },
};
</script>

<style scoped>
button {
  width: 100%;
  margin-bottom: 5px;
}

.wrapper {
  margin-top: 10px;
}
</style>
